import generic_backend_request_post from 'functions/server/generic_backend_request_post';

//json file should have locations and costss
async function deleteOptimizationResult(run_id) {
    if (!run_id) {
        throw new Error('Run ID is required for deleteOptimizationResult');
    }
    const requestJson = {
        "run_id": run_id
    }
    const retJson = generic_backend_request_post(requestJson, '/delete_optimization_result')
    return retJson;

}

export default deleteOptimizationResult